import React from 'react';

import Icon from './components/Icon';

const IconPlay = (props: any) => {
	return <Icon id="mpa-play" handle={props.handle} {...props} />;
};

export default IconPlay;
